import {Checkbox, Stack} from '@mui/material'
import React, {useState} from 'react'
import Label from '../../customTable/Label'
import InputWithLabel from '../../customTable/LabelWithText'
import UploadImg from '../../UploadImg'

import {useSelector} from 'react-redux'
import {RootState} from '../../../store'
import MainBtn from '../../customTable/MainBtn'
import ValidationFun from '../../../yup/ValidationFun'
import {AppMakerSchema} from '../../../yup/AppMakerShcema'
import {log} from 'console'
import AppMaker from '../../../Api/AppMaker'

export default function IHaveAccountsInStoresForm({
  active,
  android,
  data,
  setData,
  setIsSubmit,
}: any) {
  const [base64Image, setBase64Image] = useState('')
  const store = useSelector((state: RootState) => state.vender)
  const [isLoading, setUsLoading] = React.useState(false)
  const [errors, setErrors] = useState<any>({})

  return (
    <Stack gap='24px' p='25px' borderRadius={'8px'} bgcolor={'#fff'} mt='24px'>
      <Label text='haveAccountTitle' />
      {android ? (
        <>
          {' '}
          <Label fs='12px' fw='400' text='haveAccountSubTitleForAndroid' />
        </>
      ) : (
        <>
          {' '}
          <Label fs='12px' fw='400' text='haveAccountSubTitle' />
          <Stack direction={'row'} gap='5px' flexWrap={'wrap'}>
            <Label fs='12px' fw='400' text='checkLink' />
            <a
              href='https://idmsa.apple.com/IDMSWebAuth/signin?appIdKey=891bd3417a7776362562d2197f89480a8547b108fd934911bcbea0110d07f757&path=%2Faccount%2F&rv=1'
              target='_blank'
              rel='noopener noreferrer'
            >
              {' '}
              <Label fs='12px' fw='400' color='#009EF7' text='followingLink' />
            </a>
          </Stack>
          <Stack gap='40px'>
            <img src='./media/1.svg' alt='' />
            <Label fs='14px' text='itIsNotAcceptableIfTheAccountIsIndividual' />
            <img src='./media/2.svg' alt='' />
          </Stack>
        </>
      )}
      <InputWithLabel
        width={{md: '521px', xs: '100%'}}
        name={'duns_num'}
        data={data}
        errors={errors}
        setData={setData}
        text='DUNumber'
      />
      <Stack bgcolor={'#C5C5D8'} height={'1px'} width={'100%'}></Stack>
      <Stack gap='32px'>
        <Label text={android ? 'androidApp' : 'isoApp'} />
        <Stack gap='15px'>
          <Label text='applicationIcon' />
          <UploadImg
            name='app_icon'
            data={data}
            setData={setData}
            errors={errors}
            base64Image={base64Image}
            setBase64Image={setBase64Image}
          />
        </Stack>
        <Stack flexWrap={'wrap'} gap='32px' direction={'row'}>
          <InputWithLabel
            width={{md: 'calc(50% - 16px)', xs: '100%'}}
            name={'account_mail'}
            data={data}
            setData={setData}
            errors={errors}
            text='accountMail'
          />{' '}
          <InputWithLabel
            width={{md: 'calc(50% - 16px)', xs: '100%'}}
            name={'account_password'}
            data={data}
            errors={errors}
            setData={setData}
            text='password'
          />
        </Stack>
        <Stack bgcolor={'#C5C5D8'} height={'1px'} width={'100%'}></Stack>
      </Stack>
      <Stack>
        <Stack alignContent={'center'} gap='3px' direction={'row'}>
          <Stack
            onClick={() => {
              setData({...data, is_agree: !data.is_agree})
            }}
          >
            <Checkbox
              checked={data.is_agree}
              sx={{
                color: 'var(--main-color)',
                '&.Mui-checked': {
                  color: 'var(--main-color)',
                },
              }}
            />
          </Stack>

          <Stack mt='8px' alignContent={'center'} gap='5px' direction={'row'}>
            <Label fs={{xs: '12px', sm: '14px'}} text='iAgreeTo' />
            <a
              target={'_blank'}
              href={
                android
                  ? 'https://www.google.com/url?q=https://play.google/developer-content-policy/&sa=D&source=docs&ust=1746444439126457&usg=AOvVaw1dQVejncx0zifvD9dm8TsY'
                  : 'https://www.google.com/url?q=https://developer.apple.com/app-store/review/guidelines/&sa=D&source=docs&ust=1746444439030346&usg=AOvVaw0VADRygTSIElITkMEMcBhU'
              }
            >
              {' '}
              <Label
                fs={{xs: '12px', sm: '14px'}}
                color='#009EF7'
                text='theAppStorePublishingPolicy'
              />
            </a>
          </Stack>
        </Stack>
        {store.permissions && store.permissions && store.permissions.includes('app_maker_create') && (
          <Stack mt='41px' alignItems={'flex-end'}>
            <MainBtn
              isLoading={isLoading}
              width='auto'
              text='submit'
              handelSubmit={() => {
                ValidationFun(
                  {...data, check: data.check, active: active},
                  AppMakerSchema,
                  setErrors,
                  (value: any) => {
                    AppMaker.add(
                      {
                        ...data,
                        is_have_account: 1,
                        is_agree: data.is_agree ? 1 : 0,
                      },
                      () => {
                        setIsSubmit(true)
                      },
                      setUsLoading,
                      android
                    )
                  }
                )
              }}
            />
          </Stack>
        )}
      </Stack>
    </Stack>
  )
}
